import { apiGet, apiPost } from './api_call/api_methods'

export const fetchPolicyGroupSettings = async (policyId) => {
    if (!policyId) return { success: false, error: "Policy ID is required" };
    return apiGet({ endpoint: `${process.env.REACT_APP_POLICYSETTING_API_URL}/get_policy_settings?id=${policyId}`, error_message: "Failed to fetch policy group settings" });

};

export const updatePolicyGroupSetting = async (policyId, settingId, value) => {
    if (!policyId || !settingId) {
        return { success: false, error: "Policy ID and Setting ID are required" };
    }
    return apiPost({ endpoint: `${process.env.REACT_APP_POLICYSETTING_API_URL}/update_policy_setting?PolicyId=${policyId}&Id=${settingId}&value=${value}`, successMessage: "Policy setting updated successfully", errorMessage: "Failed to update policy setting" })
};

export const updatePolicySettingLock = async (policyId, categoryId, locked) => {
    if (!policyId || !categoryId) {
        return { success: false, error: "Policy ID and Category ID are required" };
    }
    return apiPost({ endpoint: `${process.env.REACT_APP_POLICYSETTING_API_URL}/update_policy_setting_lock?PolicyId=${policyId}&Id=${categoryId}&locked=${locked}`, successMessage: "Policy setting lock updated successfully", errorMessage: "Failed to update policy setting lock" })
};

